var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicWebLicensecode = function SvgIcLogicWebLicensecode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: 0,
    y: 0,
    viewBox: "0 0 78 78"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:currentColor}")), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_23794_00000139292012330652968880000002188235745594890112_",
    d: "M0 0h78v78H0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.814 33.694-3.253 3.252-3.253-3.252-2.767 2.767 3.253 3.253-3.253 3.253 2.767 2.767 3.253-3.252 3.253 3.252 2.767-2.767-3.252-3.253 3.252-3.252zM39.311 33.694l-3.254 3.253-3.253-3.253-2.768 2.767 3.253 3.253-3.253 3.253 2.768 2.767 3.253-3.253 3.254 3.253 2.768-2.767-3.254-3.253 3.254-3.252zM52.806 33.694l-3.252 3.252-3.253-3.252-2.767 2.767 3.252 3.253-3.252 3.253 2.767 2.767 3.253-3.252 3.252 3.252 2.768-2.767-3.253-3.253 3.253-3.252z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.262 33.138c1.315.183 2.498-.879 2.498-2.191v-8.923c0-4.544-3.694-8.239-8.239-8.239H14.48c-4.545 0-8.24 3.694-8.24 8.24v33.95c0 4.544 3.695 8.241 8.24 8.241h49.042c4.545 0 8.24-3.697 8.24-8.242v-8.922c0-1.265-1.003-2.27-2.342-2.206A5.854 5.854 0 0 1 63.674 39c0-3.225 2.622-5.848 5.588-5.863m-1.92 15.897v6.94a3.827 3.827 0 0 1-3.82 3.823H14.478a3.827 3.827 0 0 1-3.821-3.824v-33.95a3.825 3.825 0 0 1 3.821-3.82h49.042a3.825 3.825 0 0 1 3.821 3.82v6.942c-4.618 1.003-8.086 5.121-8.086 10.035s3.468 9.031 8.087 10.034",
    className: "st1"
  })));
};
export default SvgIcLogicWebLicensecode;